import { createPinia } from "pinia";
import { createApp } from "vue";
import "vuetify/dist/vuetify.min.css";
import App from "./App.vue";
import { loadRuntimeConfig } from "./config/config.ts";
import { authPlugin, initialiseAuth } from "./plugins/auth.ts";
import vuetify from "./plugins/vuetify.ts";
import router from "./router/index.ts";

let app: any;
const pinia = createPinia();

class Power_Trip_VTNZ_UI extends HTMLElement {
  async connectedCallback() {
    // Load runtime config (config.json, falling back to VITE_* build-time
    // defaults) before anything else needs it.
    await loadRuntimeConfig();

    app = createApp(App);
    app.use(router);
    app.use(pinia);
    app.use(vuetify);

    const authed = await initialiseAuth();

    app.use(authPlugin);

    if (!authed) {
      window.location.reload();
    } else {
      app.mount(this);
    }
  }
}

if (!window.customElements.get("powertrip-vtnz-ui")) {
  window.customElements.define("powertrip-vtnz-ui", Power_Trip_VTNZ_UI);
}
